import React from 'react';
import '../../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import AutoSearchPeople from "../../../../../components/auto-search-people";
import {getSchoolYear} from "../../../../../utils/authority";
import DepartmentController from "../../../../../services/data-declaration/department-controller";
import {toast} from "react-toastify";

class modalEditDepartment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: -1,
            name: '',
            description: '',
            principalId: -1,
            principalUsername: '',
            principalName: '',
            listStaff: [],
            showBlock: true,
            signupInfo: null
        };
    }
    renderListStaff() {
        return this.state.listStaff?.map((item, index) =>
            <div className="col-4 d-flex box-border-radius">
                <label className="col-10 label-item">{item.fullName}</label>
                <button className="btn btn-action"
                        title='Xóa'
                        style={{cursor: 'pointer'}}
                        onClick={() => this.deleteStaff(item.id)}
                >
                    <i className="ti-close"/>
                </button>
            </div>)
    };
    deleteStaff(id) {
        let pos = this.state.listStaff.findIndex(f => f.id === id);
        this.state.listStaff.splice(pos, 1)
        this.setState({
            listStaff: this.state.listStaff
        })
    }
    addStaff(principalId, principalUsername, principalName) {
        if (principalId === "")
            return
        let staffObj = {
            id: principalId,
            fullName: principalName
        }
        let isHave = this.state.listStaff.findIndex(f => f.id === principalId) === -1;
        if (isHave){
            this.state.listStaff.push(staffObj)
        }
        this.setState({
            listStaff: this.state.listStaff
        })
    }
    create = () => {
        let officers = []
        this.state.listStaff?.map((item, index) => {
            officers.push(item.id)
        })
        let payload = {
            id : this.state.id,
            description : this.state.description,
            name : this.state.name,
            leaderId : parseInt(this.state.principalId),
            yearId : parseInt(getSchoolYear()),
            officers : officers
        }
        DepartmentController.edit(payload, res => {
            if (res.success) {
                toast.success("Sửa tổ bộ môn thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi: "+res.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => this.detailDepartment(nextProps.id)
            )
        }
    }
    detailDepartment(userId) {
        DepartmentController.detail(userId, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        id: data.id,
                        name: data.name,
                        description: data.description,
                        principalId: data.leaderRes==null? "": data.leaderRes?.id,
                        principalName: data.leaderRes==null? "" :data.leaderRes?.fullName,
                        listStaff: data.officers,
                    },()=>{
                        this.deleteStaff(this.state.principalId)
                    }
                );
            } else {
                toast.error(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered modal-size-large">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Sửa tổ bộ môn</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex">
                                    <label className="col-4 label-item pl-0">Tên tổ bộ môn<span  style={{color: "red",}}>*</span></label>
                                    <input
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex">
                                    <label className="col-4 label-item pl-0">
                                    </label>
                                    {/*<label className="col-8 label-item pl-0">Có thể thêm nhiều tổ bộ môn cùng 1 cán bộ quảng lý ngăn cách nhau bởi dấu phẩy. Ví dụ: Tổ toán, Tổ tin</label>*/}
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Cán bộ quản lý</label>
                                    <AutoSearchPeople
                                        principalId={this.state.principalId}
                                        principalName={this.state.principalName}
                                        principalUsername={this.state.principalUsername}
                                        onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername})}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Mô tả tổ bộ môn</label>
                                    <input
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.description}
                                        onChange={(event) => {
                                            this.setState({
                                                description: event.target.value
                                            })
                                        }}
                                    />
                                </div>

                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Cán bộ thuộc bộ môn</div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Chọn cán bộ</label>
                                    <AutoSearchPeople
                                        principalId= ""
                                        principalName= ""
                                        principalUsername=""
                                        onUpdateData={(principalId, principalUsername, principalName) => this.addStaff(principalId, principalUsername, principalName)}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0 text-bold">Danh sách cán bộ</label>
                                </div>
                                <div className="col-12 d-flex mb-2 line-1"></div>
                                {this.renderListStaff()}
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.create()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export  default  modalEditDepartment
